export default {
  DISABLED: 'lost effectiveness ',
  CANCELED: 'canceled',
  REJECTED: 'not pass',
  VERIFIED: 'verified',
  PENDING: 'To audit',
  SUBMITTED: 'To submit',
  goto_fee: 'To pay cost',
  goto_edit: 'To modify',
  goods_rental: 'Goods rental',
  will_pay_with: 'Will pay with',
  the_figure: 'The figure',
  titles: 'The booth details',
  exhibiting_company: 'exhibiting company',
  linkman: 'linkman',
  contact_number: 'phone',
  '非法访问!': 'Illegal visits!',
  "展位列表": "Booth List",
  "展位概况": "Booth detail",

  "报图信息": "Report information",
  "展位基础信息": "Booth information",
  "展会费用": "Exhibition fees",
  "审核状态": "Status",
  "报图时间": "Report time",
  "承建商": "Contractor",
  "未通过报图": "Failed report",
  "去报图": "Report",
  "修改报图": "Modify the report",
  "费用缴纳": "Fee payment",
  "未缴纳用项": "Unpaid items",
  "去缴费": "Pay",

}



// WEBPACK FOOTER //
// ./src/i18n/en-us/boothInfo.js